








































































































































import { Component, Watch } from 'vue-property-decorator';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import AgencyGoalSelectionBoxes from '@/views/pages/fivgoals/AgencyGoalSelectionBoxes.vue';
import TeamGoalTable from '@/views/pages/fivgoals/components/TeamGoalTable.vue';
import { PlusIcon } from 'vue-feather-icons';
import CreateGoalModal from '@/views/pages/fivgoals/CreateGoalModal.vue';
import { IFivGoal, IGoal, IUser, UserStatus } from 'admiral-core';
import { GoalApi } from '@/services/GoalApi';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable,
    UserSelect,
    CreateGoalModal,
    PlusIcon,
    TeamGoalTable,
    AgencyGoalSelectionBoxes,
  },
})
export default class Goals extends mixins(BaseMixin) {
  goals: IGoal[] = [];
  loaded = false;

  dragOptions = {
    animation: 200,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost',
  };

  drag = false;

  selectedUser: IUser | null = null;

  get showDemo(): boolean {
    return this.$store.getters['PreferencesModule/getShowDemo'];
  }

  async mounted() {
    if (this.$route.name === 'my-goals') {
      this.selectedUser = this.user;
    } else {
      this.selectedUser = null;
    }
    await this.fetchGoals();
  }

  @Watch('showDemo')
  async onShowDemoChange() {
    await this.reload();
  }

  @Watch('$route')
  watchRoute() {
    if (this.$route.name === 'my-goals') {
      this.selectedUser = this.user;
    } else {
      this.selectedUser = null;
    }

    this.reload();
  }

  get usersOptions() {
    if (this.$route.name === 'my-goals') {
      return [this.user];
    }

    return this.users.filter((user: IUser) =>
      [UserStatus.ACTIVE, UserStatus.PENDING].includes(user.status),
    );
  }

  @Watch('selectedUser')
  watchSelectedUser() {
    this.reload();
  }

  updateUser(user: IUser) {
    this.selectedUser = user;
  }
  async reload() {
    this.loaded = false;
    await this.fetchGoals();
    this.loaded = true;
  }

  async fetchGoals() {
    try {
      const response = await GoalApi.getGoals({
        agency: this.agency,
        type: this.$route.meta.type,
        year: this.fivGoalsFilter.year || new Date().getFullYear(),
        user: this.selectedUser ? this.selectedUser : undefined,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });

      this.goals = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  get activeGoals() {
    return this.goals
      .filter((goal: IGoal) => new Date(goal.to) > new Date())
      .sort((a, b) => a.order - b.order);
  }
  set activeGoals(goals: IGoal[]) {
    // console.log(goals);
    // this.$store.commit('PreferencesModule/updateOrder', goals);
  }

  async changeOrder(changed: { newIndex: number; oldIndex: number }) {
    const newOrderedActiveGoals = this.activeGoals;
    const movedGoal = newOrderedActiveGoals.splice(changed.oldIndex, 1)[0];
    newOrderedActiveGoals.splice(changed.newIndex, 0, movedGoal);
    const goals = [...newOrderedActiveGoals];

    try {
      await GoalApi.updateGoalOrder({
        goalIds: goals.map((goal) => goal.id),
      });
    } catch (e) {
      console.log(e);
    }
    await this.reload();
    // this.$store.commit('PreferencesModule/updateOrder', this.activeGoals);
  }

  // set activeGoals(goals: IGoal[]) {
  //   console.log(goals);
  //
  //   // this.$store.commit('PreferencesModule/updateOrder', goals);
  // }

  get pastGoals() {
    return this.goals.filter((goal: IGoal) => new Date(goal.to) < new Date());
  }

  async duplicateGoal(goal: IGoal) {
    try {
      const response = await GoalApi.duplicateGoal(goal.id);
      this.goals.unshift(response.data);
      this.$toastr.s(`Ziel ${response.data.name} erfolgreich dupliziert.`, 'Ziel dupliziert');
    } catch (e) {
      this.$toastr.e(`Beim Duplizieren des Ziels ist etwas schief gelaufen.`, 'Fehler');
      throw e;
    }
  }
}
